export default "__VITE_PUBLIC_ASSET__8b3086f1__"